import api from '@/modules/axios'
import apiHelperParamsJson from '@/modules/apiHelperParamsJson'

export default {
    data() {
        return {
            loginApproachCount: 2,
            currentRequests: 0
        }
    },
    methods: {
        login(init = true, byTimeout = false) {
            return new Promise((resolve, reject) => {
                if (this.currentRequests > 0) return

                if (byTimeout && !this.$store.state.authGuestData) {
                    return
                }

                let loginUrl
                if (/\/\/localhost/.test(window.location.href)) {
                    loginUrl = 'https://api.local.effect.reg.ru/regru/regru/test-login'
                    sessionStorage.setItem('regruIntegration', loginUrl)
                } else {
                    loginUrl = JSON.parse(sessionStorage.getItem('regruIntegration'))
                        .regruSignUserLoginUrl
                }

                const xhr = new XMLHttpRequest()
                xhr.open('GET', loginUrl)
                xhr.withCredentials = true
                const self = this
                xhr.onload = function() {
                    self.currentRequests--
                    if (this.status >= 200 && this.status < 300) {
                        const resp = JSON.parse(xhr.response)
                        if (resp && resp.login && resp.sign && resp.expire) {
                            let user_id = resp.user_id

                            let authGuestData = { ...resp, user_id }
                            if (self.uuids && typeof self.uuids[resp.login] !== 'undefined') {
                                self.uuid = self.uuids[resp.login]
                            }

                            setTimeout(() => {
                                self.loginApproachCount = 2
                                self.login(true, true)
                            }, 150000)

                            self.$store.commit('setAuthGuestData', authGuestData)
                            self.$store.commit('setLastAuthGuestData', authGuestData)
                        } else {
                            self.guestLogout()
                        }
                        if (init) {
                            self.init(byTimeout ? { reason: 'login_timeout' } : {})
                        }
                        resolve(xhr.response)
                    } else {
                        self.loginFailed(xhr, 'failByStatus')
                        reject({
                            status: this.status,
                            statusText: xhr.statusText
                        })
                    }
                }
                xhr.onerror = function() {
                    self.currentRequests--
                    self.loginFailed(xhr, 'failByError')
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    })
                }
                this.currentRequests++
                xhr.send()
            })
        },

        guestLogout() {
            const authGuestData =
                this.$store.state.authGuestData || this.$store.state.lastAuthGuestData
            if (!authGuestData) {
                return
            }

            this.$store.commit('setApiActiveChatId', 0)
            this.$store.commit('setApiLastChatId', 0)

            const params = { authGuestData: authGuestData }
            this.$store.commit('setLastAuthGuestData', '')

            api.post(
                '/guest/logout',
                { ...apiHelperParamsJson(params, 'post').data },
                { headers: apiHelperParamsJson(params, 'post').headers }
            )

            if (this.$store.state.authGuestData) {
                this.$store.commit('setAuthGuestData', '')
            }
        },

        loginFailed(xhr, type) {
            const params = {
                type: type,
                status: xhr.status,
                response: xhr.response
            }
            api.post(
                'regru/regru/log-login-fail',
                { ...apiHelperParamsJson(params, 'post').data },
                { headers: apiHelperParamsJson(params, 'post').headers }
            )
            if (this.loginApproachCount) {
                setTimeout(() => {
                    this.login()
                    this.loginApproachCount--
                }, 1000)
            } else {
                setTimeout(() => {
                    this.loginApproachCount = 2
                    this.login()
                }, 10000)
            }
        }
    },

    beforeDestroy() {}
}
